import { render, staticRenderFns } from "./orderXd.vue?vue&type=template&id=75c4248e&scoped=true&"
import script from "./orderXd.vue?vue&type=script&lang=js&"
export * from "./orderXd.vue?vue&type=script&lang=js&"
import style0 from "./orderXd.vue?vue&type=style&index=0&id=75c4248e&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c4248e",
  null
  
)

export default component.exports